import React from "react";
// import Header from "./Header";
import { useNavigate } from "react-router";
import Footer from "./Footer";
import career from '../_img/career_header.png'

export default function Application() {

    const navigate = useNavigate()


    const handleSubmit = (e) => {
        e.preventDefault()
        console.log('submitted!')
        navigate('/video')
    }

    return (
        <div>
            <img src={career} alt="banner"/>
            <main className="px-[2rem] md:px-[12rem] py-[4rem]">
                <h1 className="text-companyTeal text-[1.6rem] font-[600]">Apply To Demo</h1>
                <p className="text-gray-600 mt-[3px]">Avenica - Chicago, IL, United States</p>

                <form onSubmit={(e) => handleSubmit(e)} className="mt-[3rem] grid">
                    <div className="lg:flex gap-[1rem]">
                        <div className="input-container lg:w-[50%]">
                            <label className="label" htmlFor="firstName">First Name <span className="text-red-600">*</span></label>
                            <input type="text" id="firstName" required="required" className="application-input"/>
                        </div>
                        <div className="input-container lg:w-[50%]">
                            <label className="label" htmlFor="firstName">Last Name <span className="text-red-600">*</span></label>
                            <input type="text" id="lastName" required="required" className="application-input"/>
                        </div>
                    </div>
                    <br />
                    <div className="grid mb-[1rem]">
                        <label className="label mb-[5px]" htmlFor="resume">Resume - Upload your PDF/DOC</label>
                        <input type="file" id="resume" className="text-[0.7rem] md:text-[1rem]"  />
                    </div>
                    <br />
                    <div className="lg:flex gap-[1rem]">
                        <div className="input-container lg:w-[50%]">
                            <label className="label" htmlFor="email">Email <span className="text-red-600">*</span></label>
                            <input type="text" id="email" required="required" className="application-input"/>
                        </div>
                        <div className="input-container lg:w-[50%]">
                            <label className="label" htmlFor="phone">Phone</label>
                            <input type="text" id="phone" className="application-input"/>
                        </div>
                    </div>
                    <br />
                    <div className="h-[1px] bg-gray-300"></div>
                    <br />
                    <h2 className="label text-2xl mb-[1.5rem]">About You</h2>
                    <div className="input-container w-[100%]">
                        <label className="label mb-[1rem]" htmlFor="pronouns">Do you wish to provide your pronouns? </label>
                        <select className="application-input" name="pronouns" id="pronouns">
                            <option value="">Select</option>
                            <option value="">He/Him</option>
                            <option value="">They/Them</option>
                            <option value="">Other</option>
                            <option value="">Prefer not to say</option>
                        </select>
                    </div>
                    <br />
                    <div className="input-container w-[100%]">
                        <label className="label" htmlFor="paragraph">Is there anything else you'd like us to know about you?</label>
                        <input className="application-input" type="text" id="paragraph" />

                    </div>
                    <br />
                    <div className="h-[1px] bg-gray-300"></div>
                    <br />
                    <h2 className="label text-2xl mb-[1.5rem]">Work Eligibility</h2>
                    <div className="input-container w-[100%]">
                        <label className="label mb-[1rem]" htmlFor="pronouns">Are you authorized to work in the United States? <span className="text-red-500">*</span></label>
                        <select className="application-input" required="required" name="pronouns" id="pronouns">
                            <option default value="">Select</option>
                            <option value="">Yes</option>
                            <option value="">No</option>
                        </select>
                    </div>
                    <div className="input-container w-[100%]">
                        <label className="label mb-[1rem]" htmlFor="pronouns">Do you now, or will you in future, require sponsorship? Please note, we are unable to provide sponsorship at this time. <span className="text-red-500">*</span></label>
                        <select className="application-input" required="required" name="pronouns" id="pronouns">
                            <option default value="">Select</option>
                            <option value="">Yes</option>
                            <option value="">No</option>
                        </select>
                    </div>
                    <br />
                    <div>
                        <p>About Avenica: Avenica is a platform that uses data science, behavioral psychology, and performance coaching to unleash human potential and launch careers. By getting to know candidates beyond a resume and uncovering individual potential, we propel careers across the U.S. At Avenica, we put candidates first by advocating for them through the application and interview process. Learn more about Avenica and how we can support your job search at <a className="text-blue-800 underline" target="_blank" rel="noreferrer" href="https://avenica.com/">www.avenica.com</a></p>
                    </div>
                    <button className="button mt-[4rem] w-[max-content] mx-auto" type="submit">Submit</button>
                </form>
            </main>     
        <Footer />
        </div>
       
    )
}